import React, { useState, useEffect } from 'react';
import { TabsComponent } from '../../../../Components';
import { GlobalTranslate } from '../../../../Helper';
import { tabsPermissionsHelper } from '../../../../Helper/ExceptionPermissions.Helper';
import { useTitle } from '../../../../Hooks';
import { LeaseTeamsDashboardTabs } from '../LeaseTeamsDashboardTabs/LeaseTeamsDashboardTabs';

export const LeaseTeamsDashboardTabCmp = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [dashboardTabsList, setDashboardTabsList] = useState([]);
  useTitle(GlobalTranslate.t('Dashboard:leaseteamlead-dashboard'));
  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };

  useEffect(() => {
    const list = tabsPermissionsHelper(LeaseTeamsDashboardTabs).map((field, fieldIndex) => ({
      ...field,
      index: fieldIndex,
    }));
    setDashboardTabsList(list);
  }, [LeaseTeamsDashboardTabs]);

  return (
    <div>
      <TabsComponent
        data={dashboardTabsList}
        labelInput='label'
        themeClasses='theme-curvedpowerbi'
        currentTab={activeTab}
        onTabChanged={onTabChanged}
        dynamicComponentProps={{
          setActiveTab,
          dynamicComponentLeaseTeamsProps: Object.values(dashboardTabsList).find(
            (element) => element.index === activeTab
          ),
        }}
      />
    </div>
  );
};
